import { populate } from 'populate';import dragonBones from 'pixi-dragonbones';

const raw = {
  className: 'EasterEventOfferLayout',
  width: 1350,
  height: 760,
  x: 50,
  y: 50,
  list: [
    {
      id: '35932428-2464-4112-a641-9c7a3c3eabfd',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: '5c3f2a5e-5333-4adb-bf4e-5374441ed738',
      type: 'Armature',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: '35932428-2464-4112-a641-9c7a3c3eabfd',
      data: '',
      animationName: 'animtion0',
      armatureName: 'Armature',
      dragonbonesName: 'easter_offer',
      playOnStart: true,
      progress: 0,
      playTimes: 0
    },
    {
      id: 'd0d1b581-3766-4bb7-9760-c13780a84730',
      type: 'Sprite',
      name: 'closeButton',
      nameSpace: '',
      className: '',
      x: 579,
      y: -302,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'EventDeal_X_CLOSE',
      parent: '35932428-2464-4112-a641-9c7a3c3eabfd',
      data: ''
    },
    {
      id: '506f8522-4c0d-4791-9989-44d0446fe032',
      type: 'Text',
      name: 'title',
      nameSpace: '',
      className: '',
      x: -2,
      y: -284,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'EasterOffer2022Title',
      localize: true,
      maxWidth: 480,
      maxHeight: 50,
      maxFontSize: 32,
      icons: [],
      style: {
        fontSize: 28,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#FFFFFF',
        stroke: '#821812',
        strokeThickness: 5,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 36,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: -19,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 3
      },
      parent: '35932428-2464-4112-a641-9c7a3c3eabfd',
      data: ''
    },
    {
      id: 'd5c3443b-ef15-4e4a-b14e-bae58de5217f',
      type: 'Text',
      name: 'timeText',
      nameSpace: '',
      className: '',
      x: 19,
      y: -192,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '22:23:19',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 28,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#FFFFFF',
        stroke: '#510407',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '35932428-2464-4112-a641-9c7a3c3eabfd',
      data: ''
    },
    {
      id: '7902442a-3942-4c88-a05d-9850f3a85a99',
      type: 'Text',
      name: 'description',
      nameSpace: '',
      className: '',
      x: 8,
      y: -93,
      anchor: {
        x: 0.5,
        y: 0.4
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Valentines2023OfferDescription',
      localize: true,
      maxWidth: 793,
      maxHeight: 78,
      maxFontSize: 26,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FiraSansCompressed',
        fill: '#FFFFFF',
        stroke: '',
        strokeThickness: 0,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 51,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: -19,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 2
      },
      parent: '35932428-2464-4112-a641-9c7a3c3eabfd',
      data: ''
    },
    {
      id: 'b13ead03-34da-41ff-9586-744afcc14513',
      type: 'Container',
      name: '',
      nameSpace: 'products[]',
      className: '',
      x: -245,
      y: 116,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '35932428-2464-4112-a641-9c7a3c3eabfd',
      data: ''
    },
    {
      id: '5a9fa865-1963-4399-af38-a0bec0ef56b3',
      type: 'Container',
      name: '',
      nameSpace: 'products[]',
      className: '',
      x: 0,
      y: 116,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '35932428-2464-4112-a641-9c7a3c3eabfd',
      data: ''
    },
    {
      id: '05ff9dd7-279e-4bda-9648-25a4cd5d6592',
      type: 'Container',
      name: '',
      nameSpace: 'products[]',
      className: '',
      x: 245,
      y: 116,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '35932428-2464-4112-a641-9c7a3c3eabfd',
      data: ''
    },
    {
      id: '350dda7d-912f-4b88-8d7d-c816a9b4f453',
      type: 'Container',
      name: '',
      nameSpace: 'rewards[]',
      className: '',
      x: -135,
      y: -93,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'b13ead03-34da-41ff-9586-744afcc14513',
      data: ''
    },
    {
      id: '4df0b63f-18db-4975-b848-3212bfc27a30',
      type: 'Container',
      name: '',
      nameSpace: 'rewards[]',
      className: '',
      x: -135,
      y: -52,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'b13ead03-34da-41ff-9586-744afcc14513',
      data: ''
    },
    {
      id: 'e0d7ab58-26c3-4f34-aeec-53ac970154e6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 98,
      y: -160,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'EventDeal_sticker',
      parent: 'b13ead03-34da-41ff-9586-744afcc14513',
      data: ''
    },
    {
      id: '40eb36fb-3679-4066-a521-241105ff575b',
      type: 'Container',
      name: 'unlocked',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: false,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'b13ead03-34da-41ff-9586-744afcc14513',
      data: ''
    },
    {
      id: 'd9fa0c28-3395-4746-9a19-02f06205d6d4',
      type: 'Container',
      name: 'locked',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'b13ead03-34da-41ff-9586-744afcc14513',
      data: ''
    },
    {
      id: '43a86230-9b3c-4595-bff0-eadf3e5da052',
      type: 'Container',
      name: 'purchased',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'b13ead03-34da-41ff-9586-744afcc14513',
      data: ''
    },
    {
      id: '3ea5a047-2e19-4e5e-9e9d-c2ec43a7bd87',
      type: 'Container',
      name: '',
      nameSpace: 'rewards[]',
      className: '',
      x: -135,
      y: -93,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5a9fa865-1963-4399-af38-a0bec0ef56b3',
      data: ''
    },
    {
      id: 'dfcc29bc-ee31-4dbc-ac3e-d50b0b5b673a',
      type: 'Container',
      name: '',
      nameSpace: 'rewards[]',
      className: '',
      x: -135,
      y: -52,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5a9fa865-1963-4399-af38-a0bec0ef56b3',
      data: ''
    },
    {
      id: '657a494a-da0f-4987-81ea-284153335dc6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 98,
      y: -160,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'EventDeal_sticker',
      parent: '5a9fa865-1963-4399-af38-a0bec0ef56b3',
      data: ''
    },
    {
      id: '4ecc4935-eae1-49ec-9073-6af1e4883724',
      type: 'Container',
      name: 'unlocked',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5a9fa865-1963-4399-af38-a0bec0ef56b3',
      data: ''
    },
    {
      id: '2643e7c8-763b-469f-8162-aa5899057c60',
      type: 'Container',
      name: 'locked',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5a9fa865-1963-4399-af38-a0bec0ef56b3',
      data: ''
    },
    {
      id: 'f61f14ee-6814-4e6c-b012-330b6e04c688',
      type: 'Container',
      name: 'purchased',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: false,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5a9fa865-1963-4399-af38-a0bec0ef56b3',
      data: ''
    },
    {
      id: '20d5d3f9-2c96-462c-9e3a-0728db320720',
      type: 'Container',
      name: '',
      nameSpace: 'rewards[]',
      className: '',
      x: -135,
      y: -93,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '05ff9dd7-279e-4bda-9648-25a4cd5d6592',
      data: ''
    },
    {
      id: 'ef660bd1-d836-472c-88bc-05f4065215b0',
      type: 'Container',
      name: '',
      nameSpace: 'rewards[]',
      className: '',
      x: -135,
      y: -52,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '05ff9dd7-279e-4bda-9648-25a4cd5d6592',
      data: ''
    },
    {
      id: 'dbee07c0-6b52-49aa-b6f6-a1688e6c2489',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 98,
      y: -160,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'EventDeal_sticker',
      parent: '05ff9dd7-279e-4bda-9648-25a4cd5d6592',
      data: ''
    },
    {
      id: '0a833c7f-8703-42ca-bdf2-e50d43064701',
      type: 'Container',
      name: 'unlocked',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: false,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '05ff9dd7-279e-4bda-9648-25a4cd5d6592',
      data: ''
    },
    {
      id: '3f5736ba-8668-436f-b76a-77796885253a',
      type: 'Container',
      name: 'locked',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '05ff9dd7-279e-4bda-9648-25a4cd5d6592',
      data: ''
    },
    {
      id: 'af246eae-1377-4b09-8c3b-33e5762aa166',
      type: 'Container',
      name: 'purchased',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: false,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '05ff9dd7-279e-4bda-9648-25a4cd5d6592',
      data: ''
    },
    {
      id: '26fb62df-3767-475c-b4b6-b94e590ba742',
      type: 'Sprite',
      name: 'icon',
      nameSpace: '',
      className: '',
      x: 65,
      y: -13,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'coin_icon',
      parent: '350dda7d-912f-4b88-8d7d-c816a9b4f453',
      data: ''
    },
    {
      id: 'd8411950-fa58-456c-b832-81dba3668eb0',
      type: 'Text',
      name: 'value',
      nameSpace: '',
      className: '',
      x: 100,
      y: 6,
      anchor: {
        x: 0,
        y: 1
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'x 9999999',
      localize: false,
      maxWidth: 120,
      maxHeight: 35,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#6c0211',
        strokeThickness: 2,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '350dda7d-912f-4b88-8d7d-c816a9b4f453',
      data: ''
    },
    {
      id: '0824eaf5-5e4e-4b77-8bd9-996a68fddb4c',
      type: 'Sprite',
      name: 'icon',
      nameSpace: '',
      className: '',
      x: 65,
      y: 5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'EventDeal_freeLVL',
      parent: '4df0b63f-18db-4975-b848-3212bfc27a30',
      data: ''
    },
    {
      id: '993f9809-4bf3-4ddd-82eb-979373996c9f',
      type: 'Text',
      name: 'value',
      nameSpace: '',
      className: '',
      x: 100,
      y: 20,
      anchor: {
        x: 0,
        y: 1
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'x 9999999',
      localize: false,
      maxWidth: 120,
      maxHeight: 35,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#6c0211',
        strokeThickness: 2,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '4df0b63f-18db-4975-b848-3212bfc27a30',
      data: ''
    },
    {
      id: '56bc016c-01c0-4064-92a0-a7bd38d75924',
      type: 'Text',
      name: 'percent',
      nameSpace: '',
      className: '',
      x: 6,
      y: 9,
      anchor: {
        x: 0.5,
        y: 1
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: -14,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '10%',
      localize: false,
      maxWidth: 60,
      maxHeight: 49,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'MyriadProBlack',
        fill: 'white',
        stroke: '#f60f0d',
        strokeThickness: 5,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'e0d7ab58-26c3-4f34-aeec-53ac970154e6',
      data: ''
    },
    {
      id: '89e7fe4f-a14a-4042-8148-f1b7f4004c51',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 3,
      y: -1,
      anchor: {
        x: 0.5,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: -14,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'More',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 21,
      icons: [],
      style: {
        fontSize: 21,
        fontWeight: 'normal',
        fontFamily: 'MyriadProBlack',
        fill: '#f60f0d',
        stroke: '',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'e0d7ab58-26c3-4f34-aeec-53ac970154e6',
      data: ''
    },
    {
      id: '7a48380e-8246-4ffd-9feb-d4ccc43e18ec',
      type: 'Sprite',
      name: 'buy_button',
      nameSpace: 'buyButtons[]',
      className: '',
      x: 0,
      y: 140,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.2,
        y: 1.2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'EventDeal_Button_green',
      parent: '40eb36fb-3679-4066-a521-241105ff575b',
      data: ''
    },
    {
      id: 'a201cd4a-3e5a-43e1-8683-2a2f8a559315',
      type: 'Sprite',
      name: '',
      nameSpace: 'buyButtons[]',
      className: '',
      x: 0,
      y: 140,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.2,
        y: 1.2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'EventDeal_Button_grey',
      parent: 'd9fa0c28-3395-4746-9a19-02f06205d6d4',
      data: ''
    },
    {
      id: 'c7983b96-d431-460f-a5bd-f0b65ac629ca',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 14,
      y: -22,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'EventDeal_shadow',
      parent: '43a86230-9b3c-4595-bff0-eadf3e5da052',
      data: ''
    },
    {
      id: 'd2940892-8d80-4154-951d-6f3a549f5325',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'EventDeal_check',
      parent: '43a86230-9b3c-4595-bff0-eadf3e5da052',
      data: ''
    },
    {
      id: '4f25515d-cb2f-4aa0-aee8-a1652837f2dd',
      type: 'Sprite',
      name: 'icon',
      nameSpace: '',
      className: '',
      x: 65,
      y: -13,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'coin_icon',
      parent: '3ea5a047-2e19-4e5e-9e9d-c2ec43a7bd87',
      data: ''
    },
    {
      id: '1a2e3620-e22c-43bd-97d8-a8e9c4fa6e2b',
      type: 'Text',
      name: 'value',
      nameSpace: '',
      className: '',
      x: 100,
      y: 6,
      anchor: {
        x: 0,
        y: 1
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'x 9999999',
      localize: false,
      maxWidth: 120,
      maxHeight: 35,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#6c0211',
        strokeThickness: 2,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '3ea5a047-2e19-4e5e-9e9d-c2ec43a7bd87',
      data: ''
    },
    {
      id: '88b8af85-d6d3-4735-b0ae-6ea4bd286728',
      type: 'Sprite',
      name: 'icon',
      nameSpace: '',
      className: '',
      x: 65,
      y: 5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'EventDeal_plus5card',
      parent: 'dfcc29bc-ee31-4dbc-ac3e-d50b0b5b673a',
      data: ''
    },
    {
      id: '9e6089f4-1f41-4cf1-ba65-eed288f0beda',
      type: 'Text',
      name: 'value',
      nameSpace: '',
      className: '',
      x: 100,
      y: 20,
      anchor: {
        x: 0,
        y: 1
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'x 9999999',
      localize: false,
      maxWidth: 120,
      maxHeight: 35,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#6c0211',
        strokeThickness: 2,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'dfcc29bc-ee31-4dbc-ac3e-d50b0b5b673a',
      data: ''
    },
    {
      id: 'bc559c2b-d4bf-4cd8-94c0-3d536445bc28',
      type: 'Text',
      name: 'percent',
      nameSpace: '',
      className: '',
      x: 6,
      y: 9,
      anchor: {
        x: 0.5,
        y: 1
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: -14,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '10%',
      localize: false,
      maxWidth: 60,
      maxHeight: 49,
      maxFontSize: 26,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'MyriadProBlack',
        fill: 'white',
        stroke: '#f60f0d',
        strokeThickness: 5,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '657a494a-da0f-4987-81ea-284153335dc6',
      data: ''
    },
    {
      id: '4239b977-c49b-4014-b105-a42b4efeca8c',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 3,
      y: -1,
      anchor: {
        x: 0.5,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: -14,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'More',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 21,
      icons: [],
      style: {
        fontSize: 21,
        fontWeight: 'normal',
        fontFamily: 'MyriadProBlack',
        fill: '#f60f0d',
        stroke: '',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '657a494a-da0f-4987-81ea-284153335dc6',
      data: ''
    },
    {
      id: '7063ca8d-21ff-4ede-b319-b2a2fb399eaa',
      type: 'Sprite',
      name: 'buy_button',
      nameSpace: 'buyButtons[]',
      className: '',
      x: 0,
      y: 140,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.2,
        y: 1.2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'EventDeal_Button_green',
      parent: '4ecc4935-eae1-49ec-9073-6af1e4883724',
      data: ''
    },
    {
      id: '25cf40fc-aa42-43be-b20c-fe0c7177d694',
      type: 'Sprite',
      name: '',
      nameSpace: 'buyButtons[]',
      className: '',
      x: 0,
      y: 140,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.2,
        y: 1.2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'EventDeal_Button_grey',
      parent: '2643e7c8-763b-469f-8162-aa5899057c60',
      data: ''
    },
    {
      id: '7409029d-74ba-40f3-b85f-65a47f86ce2c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 14,
      y: -22,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'EventDeal_shadow',
      parent: 'f61f14ee-6814-4e6c-b012-330b6e04c688',
      data: ''
    },
    {
      id: '1cd2cf80-0614-48a0-9478-0600f919e081',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'EventDeal_check',
      parent: 'f61f14ee-6814-4e6c-b012-330b6e04c688',
      data: ''
    },
    {
      id: '9697d5d2-4d73-4104-8abd-6e6e8bb214e3',
      type: 'Sprite',
      name: 'icon',
      nameSpace: '',
      className: '',
      x: 65,
      y: -13,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'coin_icon',
      parent: '20d5d3f9-2c96-462c-9e3a-0728db320720',
      data: ''
    },
    {
      id: '8a6255c5-1ad4-4207-b914-5cad34b0e91e',
      type: 'Text',
      name: 'value',
      nameSpace: '',
      className: '',
      x: 100,
      y: 6,
      anchor: {
        x: 0,
        y: 1
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'x 9999999',
      localize: false,
      maxWidth: 120,
      maxHeight: 35,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#6c0211',
        strokeThickness: 2,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '20d5d3f9-2c96-462c-9e3a-0728db320720',
      data: ''
    },
    {
      id: '284c3ce6-ce07-45b0-9831-0d8bf1672590',
      type: 'Sprite',
      name: 'icon',
      nameSpace: '',
      className: '',
      x: 65,
      y: 5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'EventDeal_Joker',
      parent: 'ef660bd1-d836-472c-88bc-05f4065215b0',
      data: ''
    },
    {
      id: '07a2653d-26ae-4b3f-829b-b90d6e3037e9',
      type: 'Text',
      name: 'value',
      nameSpace: '',
      className: '',
      x: 100,
      y: 20,
      anchor: {
        x: 0,
        y: 1
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'x 9999999',
      localize: false,
      maxWidth: 120,
      maxHeight: 35,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#6c0211',
        strokeThickness: 2,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'ef660bd1-d836-472c-88bc-05f4065215b0',
      data: ''
    },
    {
      id: 'f8d7bffc-dbdb-4ee8-99d2-67710355f663',
      type: 'Text',
      name: 'percent',
      nameSpace: '',
      className: '',
      x: 5,
      y: 8,
      anchor: {
        x: 0.5,
        y: 1
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: -14,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '10%',
      localize: false,
      maxWidth: 60,
      maxHeight: 49,
      maxFontSize: 26,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'MyriadProBlack',
        fill: 'white',
        stroke: '#f60f0d',
        strokeThickness: 5,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'dbee07c0-6b52-49aa-b6f6-a1688e6c2489',
      data: ''
    },
    {
      id: '00dc3a1e-b9b2-4529-9a3d-ef318dc387ec',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 3,
      y: -1,
      anchor: {
        x: 0.5,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: -14,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'More',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 21,
      icons: [],
      style: {
        fontSize: 21,
        fontWeight: 'normal',
        fontFamily: 'MyriadProBlack',
        fill: '#f60f0d',
        stroke: '',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'dbee07c0-6b52-49aa-b6f6-a1688e6c2489',
      data: ''
    },
    {
      id: '70807aca-62fd-4776-b606-424b2f873898',
      type: 'Sprite',
      name: 'buy_button',
      nameSpace: 'buyButtons[]',
      className: '',
      x: 2,
      y: 140,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.2,
        y: 1.2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'EventDeal_Button_green',
      parent: '0a833c7f-8703-42ca-bdf2-e50d43064701',
      data: ''
    },
    {
      id: '2a682de0-9ef8-4d7c-ace7-9a263cd25402',
      type: 'Sprite',
      name: '',
      nameSpace: 'buyButtons[]',
      className: '',
      x: 2,
      y: 140,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.2,
        y: 1.2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'EventDeal_Button_grey',
      parent: '3f5736ba-8668-436f-b76a-77796885253a',
      data: ''
    },
    {
      id: '1069a6f8-de45-462d-9a92-3b39f402202d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 14,
      y: -22,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'EventDeal_shadow',
      parent: 'af246eae-1377-4b09-8c3b-33e5762aa166',
      data: ''
    },
    {
      id: 'f4e39f3d-7cb3-466f-b64e-a4372b899c6f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'EventDeal_check',
      parent: 'af246eae-1377-4b09-8c3b-33e5762aa166',
      data: ''
    },
    {
      id: '913df3d4-4165-4b94-a273-e3718e2a7591',
      type: 'Text',
      name: 'oldPrice',
      nameSpace: '',
      className: '',
      x: 0,
      y: -16,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '$ 14.99',
      localize: false,
      maxWidth: 68,
      maxHeight: 28,
      maxFontSize: 28,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#FFF600',
        stroke: '#17762E',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '7a48380e-8246-4ffd-9feb-d4ccc43e18ec',
      data: ''
    },
    {
      id: '8b69c7dc-9ef9-4d63-9fa4-e7c6eb5286e1',
      type: 'Text',
      name: 'strike',
      nameSpace: '',
      className: '',
      x: 0,
      y: -15,
      anchor: {
        x: 0.5,
        y: 0.65
      },
      scale: {
        x: 2,
        y: 1
      },
      angle: -15,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '━',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ff075a',
        stroke: '#17762E',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '7a48380e-8246-4ffd-9feb-d4ccc43e18ec',
      data: ''
    },
    {
      id: '652f8dc1-f326-43d7-a390-fc97c2dc89a1',
      type: 'Text',
      name: 'priceText',
      nameSpace: '',
      className: '',
      x: 0,
      y: 7,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '$ 9.99',
      localize: false,
      maxWidth: 114,
      maxHeight: 34,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 45,
        fontWeight: 'normal',
        fontFamily: 'ArchivoBlack',
        fill: 'white',
        stroke: '#17762E',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '7a48380e-8246-4ffd-9feb-d4ccc43e18ec',
      data: ''
    },
    {
      id: '2a57de73-88b7-4954-a6a9-8034de8dfe88',
      type: 'Text',
      name: 'oldPrice',
      nameSpace: '',
      className: '',
      x: 0,
      y: -16,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '$ 14.99',
      localize: false,
      maxWidth: 68,
      maxHeight: 28,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#CCCCCC',
        stroke: '#404040',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'a201cd4a-3e5a-43e1-8683-2a2f8a559315',
      data: ''
    },
    {
      id: '05849d4b-adbd-4d45-989b-0b45ede046d3',
      type: 'Text',
      name: 'strike',
      nameSpace: '',
      className: '',
      x: 0,
      y: -15,
      anchor: {
        x: 0.5,
        y: 0.65
      },
      scale: {
        x: 2,
        y: 1
      },
      angle: -15,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '━',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ff075a',
        stroke: '#17762E',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'a201cd4a-3e5a-43e1-8683-2a2f8a559315',
      data: ''
    },
    {
      id: 'b569af80-3529-4be7-8f78-476c6b601bed',
      type: 'Text',
      name: 'priceText',
      nameSpace: '',
      className: '',
      x: 0,
      y: 7,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '$ 9.99',
      localize: false,
      maxWidth: 90,
      maxHeight: 34,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 45,
        fontWeight: 'normal',
        fontFamily: 'ArchivoBlack',
        fill: '#FFFFFF',
        stroke: '#404040',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'a201cd4a-3e5a-43e1-8683-2a2f8a559315',
      data: ''
    },
    {
      id: '83403bba-d760-413e-b9b5-603a57024036',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -53,
      y: -1,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'EventDeal_lock',
      parent: 'a201cd4a-3e5a-43e1-8683-2a2f8a559315',
      data: ''
    },
    {
      id: '97f08135-9ab3-40cf-ab86-a16321b1ae9f',
      type: 'Text',
      name: 'oldPrice',
      nameSpace: '',
      className: '',
      x: 0,
      y: -16,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '$ 14.99',
      localize: false,
      maxWidth: 68,
      maxHeight: 28,
      maxFontSize: 28,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#FFF600',
        stroke: '#17762E',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '7063ca8d-21ff-4ede-b319-b2a2fb399eaa',
      data: ''
    },
    {
      id: '0ca6a847-972f-447f-b3b1-d1a3d7357bc9',
      type: 'Text',
      name: 'strike',
      nameSpace: '',
      className: '',
      x: 0,
      y: -15,
      anchor: {
        x: 0.5,
        y: 0.65
      },
      scale: {
        x: 2,
        y: 1
      },
      angle: -15,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '━',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ff075a',
        stroke: '#17762E',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '7063ca8d-21ff-4ede-b319-b2a2fb399eaa',
      data: ''
    },
    {
      id: '06f9c324-8e07-482b-85c2-f54c54554f9a',
      type: 'Text',
      name: 'priceText',
      nameSpace: '',
      className: '',
      x: 0,
      y: 7,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '$ 9.99',
      localize: false,
      maxWidth: 90,
      maxHeight: 34,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 45,
        fontWeight: 'normal',
        fontFamily: 'ArchivoBlack',
        fill: 'white',
        stroke: '#17762E',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '7063ca8d-21ff-4ede-b319-b2a2fb399eaa',
      data: ''
    },
    {
      id: '2414e43f-0333-4e41-b0c0-121f6a827a55',
      type: 'Text',
      name: 'oldPrice',
      nameSpace: '',
      className: '',
      x: 0,
      y: -16,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '$ 14.99',
      localize: false,
      maxWidth: 68,
      maxHeight: 28,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#CCCCCC',
        stroke: '#404040',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '25cf40fc-aa42-43be-b20c-fe0c7177d694',
      data: ''
    },
    {
      id: '05a0109a-b978-4dd8-a4f0-038e75e15186',
      type: 'Text',
      name: 'strike',
      nameSpace: '',
      className: '',
      x: 0,
      y: -15,
      anchor: {
        x: 0.5,
        y: 0.65
      },
      scale: {
        x: 2,
        y: 1
      },
      angle: -15,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '━',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ff075a',
        stroke: '#17762E',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '25cf40fc-aa42-43be-b20c-fe0c7177d694',
      data: ''
    },
    {
      id: 'acb91083-ab7a-448d-a8c3-4ad5758e83e6',
      type: 'Text',
      name: 'priceText',
      nameSpace: '',
      className: '',
      x: 0,
      y: 7,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '$ 9.99',
      localize: false,
      maxWidth: 90,
      maxHeight: 34,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 45,
        fontWeight: 'normal',
        fontFamily: 'ArchivoBlack',
        fill: '#FFFFFF',
        stroke: '#404040',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '25cf40fc-aa42-43be-b20c-fe0c7177d694',
      data: ''
    },
    {
      id: '68707882-1cb7-4687-afea-8af93beb3765',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -53,
      y: -1,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'EventDeal_lock',
      parent: '25cf40fc-aa42-43be-b20c-fe0c7177d694',
      data: ''
    },
    {
      id: '44467008-06f0-4053-82ac-5e713e56e204',
      type: 'Text',
      name: 'oldPrice',
      nameSpace: '',
      className: '',
      x: 0,
      y: -16,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '$ 14.99',
      localize: false,
      maxWidth: 68,
      maxHeight: 28,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#FFF600',
        stroke: '#17762E',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '70807aca-62fd-4776-b606-424b2f873898',
      data: ''
    },
    {
      id: 'c0ecc749-45df-4b56-bdcf-3a910ebcef0d',
      type: 'Text',
      name: 'strike',
      nameSpace: '',
      className: '',
      x: 0,
      y: -15,
      anchor: {
        x: 0.5,
        y: 0.65
      },
      scale: {
        x: 2,
        y: 1
      },
      angle: -15,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '━',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ff075a',
        stroke: '#17762E',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '70807aca-62fd-4776-b606-424b2f873898',
      data: ''
    },
    {
      id: 'f92d68d7-c1e1-4ad8-abef-a471ad4ef50b',
      type: 'Text',
      name: 'priceText',
      nameSpace: '',
      className: '',
      x: 0,
      y: 7,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '$ 9.99',
      localize: false,
      maxWidth: 90,
      maxHeight: 34,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 45,
        fontWeight: 'normal',
        fontFamily: 'ArchivoBlack',
        fill: '#FFFFFF',
        stroke: '#17762E',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '70807aca-62fd-4776-b606-424b2f873898',
      data: ''
    },
    {
      id: '2d70ee6f-a863-4790-a514-e0202abad521',
      type: 'Text',
      name: 'oldPrice',
      nameSpace: '',
      className: '',
      x: 0,
      y: -16,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '$ 14.99',
      localize: false,
      maxWidth: 68,
      maxHeight: 28,
      maxFontSize: 28,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#CCCCCC',
        stroke: '#404040',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '2a682de0-9ef8-4d7c-ace7-9a263cd25402',
      data: ''
    },
    {
      id: 'da6d1537-ee58-4153-ba06-2a6cd405ddd9',
      type: 'Text',
      name: 'strike',
      nameSpace: '',
      className: '',
      x: 0,
      y: -15,
      anchor: {
        x: 0.5,
        y: 0.65
      },
      scale: {
        x: 2,
        y: 1
      },
      angle: -15,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '━',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ff075a',
        stroke: '#17762E',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '2a682de0-9ef8-4d7c-ace7-9a263cd25402',
      data: ''
    },
    {
      id: '15fc8e34-db07-46ea-8969-9e6f072a4cf2',
      type: 'Text',
      name: 'priceText',
      nameSpace: '',
      className: '',
      x: 0,
      y: 7,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '$ 9.99',
      localize: false,
      maxWidth: 90,
      maxHeight: 34,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 45,
        fontWeight: 'normal',
        fontFamily: 'ArchivoBlack',
        fill: '#FFFFFF',
        stroke: '#404040',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '2a682de0-9ef8-4d7c-ace7-9a263cd25402',
      data: ''
    },
    {
      id: '9c0e1e55-fc3a-455d-942d-6c70cbee120e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -53,
      y: -1,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'EventDeal_lock',
      parent: '2a682de0-9ef8-4d7c-ace7-9a263cd25402',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class EasterEventOfferLayout {
  static raw = raw;
  root: PIXI.Container
  closeButton: PIXI.Sprite
  title: PIXI.Text
  timeText: PIXI.Text
  description: PIXI.Text
  products: ({
    percent: PIXI.Text
    unlocked: PIXI.Container
    buy_button: PIXI.Sprite
    locked: PIXI.Container
    purchased: PIXI.Container
    rewards: ({
      icon: PIXI.Sprite
      value: PIXI.Text
      children: (PIXI.Sprite | PIXI.Text)[]
    })[]
    buyButtons: ({
      oldPrice: PIXI.Text
      strike: PIXI.Text
      priceText: PIXI.Text
      children: (PIXI.Text)[]
    } | {
      oldPrice: PIXI.Text
      strike: PIXI.Text
      priceText: PIXI.Text
      children: (PIXI.Text | PIXI.Sprite)[]
    })[]
    children: (PIXI.Container | PIXI.Sprite)[]
  })[]

  constructor() {
    populate(this, raw);
  }
}
